import api from '../../../api';

export type TermsAndConditionsResponse = {
  accepted: boolean;
  neverAccepted: boolean;
};

export async function fetchTermsAndConditions(studioGroup: StudioGroup) {
  const response = await api.get<TermsAndConditionsResponse>(`studio/user/${studioGroup}/terms-and-conditions`);

  return response.data;
}

export type PrivacyPolicyResponse = {
  accepted: boolean;
  neverAccepted: boolean;
};

export async function fetchPrivacyPolicy(studioGroup: StudioGroup) {
  const response = await api.get<PrivacyPolicyResponse>(`studio/user/${studioGroup}/privacy-policy`);

  return response.data;
}

async function acceptTermsAndConditions(studioGroup: StudioGroup) {
  await api.put(`studio/user/${studioGroup}/terms-and-conditions/accept`);
}

async function acceptPrivacyPolicy(studioGroup: StudioGroup) {
  await api.put(`studio/user/${studioGroup}/privacy-policy/accept`);
}

export async function acceptTermsOfUse(studioGroup: StudioGroup) {
  await Promise.all([acceptTermsAndConditions(studioGroup), acceptPrivacyPolicy(studioGroup)]);
}
